export const CURRENCY = "$";
export var recordsLimit = 10;
export var recordsLimit50 = 50;

export const googleMapApiKey = "";

export const falsyArray = [
  null,
  undefined,
  "",
  0,
  false,
  NaN,
  "null",
  "undefined",
  "false",
  "0",
  "NaN",
];
export const fileTypesAllowed = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "video/mp4",
  "video/mpeg",
  "video/quicktime",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
export const videoFileTypes = ["mp4", "mpeg", "quicktime"];

export const allowedFileTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "image/*": [".png", ".jpeg", ".jpg"],
};
export const allowedDocTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
};
export const allowedImageTypes = {
  "image/*": [".png", ".jpeg", ".jpg", ".jfif", ".webp"],
};

export const STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};
export const USER_STATUS = {
  ACTIVE: "active",
  INACTIVE: "system-deactivated",
  VERIFICATION_PENDING: "verification-pending",
};

// permission route
export const permissionRoute = {
  "/cms": "cms-management",
  "/add-edit-banner": "cms-management",
  "/role-management": "role-management",
  "/add-role": "role-management",
  "/edit-role": "role-management",
  "/orders": "order-management",
  "/user-management": "user-management",
  "/analytics-report": "report-management",
  "/staff-management": "staff-management",
  "/products": "product-management",
  "/add-product": "product-management",
  "/edit-product": "product-management",
  "/add-edit-campaign": "promotion-code-management",
  "/add-edit-voucher": "voucher-management",
  "/promotion-vouchers": ["promotion-code-management", "voucher-management"],
  "/support-management": "support-management",
  "/shapes": "cruds-management",
  "/colours": "cruds-management",
  "/coins": "cruds-management",
  "/categories": "cruds-management",
  "/lengths": "cruds-management",
  "/styles": "cruds-management",
  "/countries": "cruds-management",
};
export const notProtectedRoute = ["/login", "/", "/settings", "/notifications"];
export const defaultPermissions = [
  { "user-management": ["read"] },
  { "order-management": ["read"] },
  { "report-management": ["read"] },
  { "promotion-code-management": ["read"] },
  { "voucher-management": ["read"] },
  { "cms-management": ["read"] },
  { "staff-management": ["read"] },
  { "product-management": [] },
];

export const MAIN_PERMISSION = {
  CMS: "cms-management",
  ROLE: "role-management",
  ORDER: "order-management",
  USER: "user-management",
  REPORT: "report-management",
  STAFF: "staff-management",
  PRODUCTS: "product-management",
  PROMOTION: "promotion-code-management",
  VOUCHER: "voucher-management",
  SUPPORT: "support-management",
  CRUD: "cruds-management",

  //  This is for the history management which is used in the order management only for view history
  HISTORY: "history-management",
};
export const SUB_PERMISSION = {
  CREATE: "create",
  READ: "read",
  UPDATE: "update",
  DELETE: "delete",
};

export const PRODUCT_TYPE = {
  PRESS_ON: "press-on",
  CUSTOM: "custom",
  ACCESSORIES: "accessories",
};
export const VOUCHER_TYPE = {
  REFERRAL: "referral",
  GENERAL: "general",
};

// CREDIT_CARD = 'credit',
//   DEBIT_CARD = 'debit',
//   PAYPAL = 'paypal',
//   GOOGLE_PAY = 'google-pay',
//   APPLE_PAY = 'apple-pay',
//   SHOPIFY_PAY = 'shopify_payments',
//   OTHER = 'other',
export const PAYMENT_METHOD = {
  CREDIT_CARD: "credit",
  DEBIT_CARD: "debit",
  PAYPAL: "paypal",
  GOOGLE_PAY: "google-pay",
  APPLE_PAY: "apple-pay",
  SHOPIFY_PAY: "shopify_payments",
};
export const paymentMethodOptions = [
  { label: "All", value: "all" },
  { label: "Credit", value: PAYMENT_METHOD.CREDIT_CARD },
  { label: "Debit", value: PAYMENT_METHOD.DEBIT_CARD },
  { label: "Apple Pay", value: PAYMENT_METHOD.APPLE_PAY },
  { label: "Google Pay", value: PAYMENT_METHOD.GOOGLE_PAY },
  { label: "Paypal", value: PAYMENT_METHOD.PAYPAL },
  { label: "Shopify Pay", value: PAYMENT_METHOD.SHOPIFY_PAY },
];
export const SIZE_ENUM = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  EXTRA_LARGE: "extra-large",
};
export const SIZE_OPTIONS = [
  { label: "Small", value: SIZE_ENUM.SMALL },
  { label: "Medium", value: SIZE_ENUM.MEDIUM },
  { label: "Large", value: SIZE_ENUM.LARGE },
  { label: "Extra Large", value: SIZE_ENUM.EXTRA_LARGE },
];

export const BANNER_TYPE = {
  PRODUCT: "product",
  CAMPAIGN: "campaign",
  ADVERTIZEMENT: "advertizement",
};
export const bannerTypeOptions = [
  { label: "Product", value: BANNER_TYPE.PRODUCT },
  { label: "Campaign", value: BANNER_TYPE.CAMPAIGN },
  { label: "Advertizement", value: BANNER_TYPE.ADVERTIZEMENT },
];
